import React from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import Typography, { TypographyProps } from 'atoms/Typography/Typography';
import AssetWrapper from 'atoms/Asset/AssetWrapper';
import Stack from 'atoms/Layout/Stack/Stack';
import { BackgroundImageContainer } from './OneLinerContainer.styles';
import { useOneLinerBackgroundVariant, OneLinerVariant } from './useOneLinerBackgroundVariant';

export interface OneLinerContainerProps {
  variant?: OneLinerVariant;
  backgroundOverride?: IGatsbyImageData;
  text: TypographyProps;
  className?: string;
}

const OneLinerContainer = ({ variant, backgroundOverride, text, className }: OneLinerContainerProps): JSX.Element => {
  const variantBackground = useOneLinerBackgroundVariant(variant);
  const backgroundImage = backgroundOverride || variantBackground;

  return (
    <Stack
      position='relative'
      padding='spacing-6xl'
      borderRadius='radius-2xl'
      overflow='hidden'
      className={className}
    >
      {backgroundImage && (
        <BackgroundImageContainer>
          <AssetWrapper
            imageProps={{
              image: backgroundImage,
              alt: 'Background image',
              loading: 'eager',
            }}
            cover
          />
        </BackgroundImageContainer>
      )}
      <Stack
        position='relative'
        zIndex={2}
        justify='center'
        align='flex-end'
      >
        <Typography
          type='heading'
          size='sm'
          as='p'
          color='text-white'
          fontWeight='font-weight-semibold'
          {...text}
        />
      </Stack>
    </Stack>
  );
};

export default OneLinerContainer;
